import { useMemo } from 'react';
import { useJiraSoftwareProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { useDlpEntitlement } from '@atlassian/jira-tenant-context-controller/src/components/dlp-entitlement/index.tsx';
import type { UseNextgenSidebarSettings } from './types.tsx';
import { extractData } from './utils/extract-data.tsx';

export const useNextgenSidebarSettings: UseNextgenSidebarSettings = (features) => {
	const { data, loading, error } = useJiraSoftwareProjectNavigation();
	const hasDlpEnabled = useDlpEntitlement();

	const extractedData = useMemo(
		() => (data && features ? extractData(data, features, hasDlpEnabled) : null),
		[data, features, hasDlpEnabled],
	);

	return {
		data: extractedData,
		loading,
		error,
	};
};
